import React from "react";
import "./LoadingComponent.css";

const LoadingComponent = ({ isActive = false }) => {
  if (!isActive) return null;

  return (
    <div className="loading-overlay">
      <div className="bar-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default LoadingComponent;
